import React from "react";
import { useLang } from "../context/LanguageContext";

export const Logo = ({ className = "", variant = "full" }) => {
  const { lang } = useLang();
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <img
        src="/logo.png"
        alt="Ashish Point"
        className="h-11 w-11 object-contain shrink-0"
        loading="eager"
      />
      {variant === "full" && (
        <div className="leading-tight">
          <div className="font-heading font-semibold text-slate-900 text-lg">
            {lang === "hi" ? "आशीष पॉइंट" : "Ashish Point"}
          </div>
          <div className="text-[10px] uppercase tracking-[0.14em] text-orange-600 font-semibold">
            {lang === "hi" ? "सर्वश्रेष्ठ सेवा प्रदाता" : "Best Service Provider"}
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
